import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/src/themes'

const GALLERY_IMAGE_HEIGHT = 160

export const Root = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
`

export const GalleryImage = styled.div<{imageHeight?: number}>`
  width: 100%;
  height: 100%;
  position: relative;

  img {
    width: 100% !important;
    height: ${({imageHeight}) =>
      imageHeight ?? GALLERY_IMAGE_HEIGHT}px !important;
    object-fit: cover !important;
    object-position: center !important;
    display: block;
  }
`

export const SlideSkeleton = styled(SkeletonLoader)`
  width: 100%;
`

export const Viewport = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const Scroller = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar on mobile while keeping functionality */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`

export const Slide = styled.div`
  flex: 0 0 100%;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  position: relative;
`

export const DotsWrapper = styled.nav`
  display: flex;
  gap: ${cssTheme.layout.spacing.s250};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 44px;
  align-items: center;
  overflow-x: hidden;
  scroll-snap-type: x mandatory;
  width: 100px;
  margin: 0 auto;
  & > :first-child {
    margin-inline-start: 50px;
  }
  & > :last-child {
    margin-inline-end: 50px;
  }
`

export const Dot = styled.div`
  width: ${cssTheme.layout.spacing.s300};
  min-width: ${cssTheme.layout.spacing.s300};
  height: ${cssTheme.layout.spacing.s300};
  min-height: ${cssTheme.layout.spacing.s300};
  border-radius: 50%;
  background: ${cssTheme.colors.background.neutral.primary};
  opacity: 0.5;
  flex-shrink: 0;
  &.--active-dot {
    opacity: 1;
  }

  &.--small-dot {
    transform: scale(0.5);
  }
  &.--extra-small-dot {
    transform: scale(0.3333);
  }
`
